window.addEventListener('load', function() {
  setTimeout(function() {
    var script = document.createElement('script');
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.setAttribute('data-cbid', '72afbf44-ec22-4da1-aacb-628fac2eb353');
    script.type = 'text/javascript';
    script.async = true;  // Ensure the script loads asynchronously
    document.body.appendChild(script);
  }, 2000); // Delay loading by 2 seconds
});